import { useSyncExternalStore } from "react";
import { trafficTracker } from "@/utils/trafficTracker";
const serverSnapshot = {
  enabled: false,
  recording: false,
  activeStartedAt: null,
  activeEvents: [],
  totals: {
    backend: 0,
    cacheReads: 0,
    cacheHits: 0,
    cacheMisses: 0,
    cacheWrites: 0,
    versionChecks: 0,
    merges: 0
  },
  byUrl: [],
  dailyTotals: {
    backend: 0,
    cacheReads: 0,
    cacheHits: 0,
    cacheMisses: 0,
    cacheWrites: 0,
    versionChecks: 0,
    merges: 0
  },
  dailyDate: "",
  savedSessions: [],
  pageLoadMode: false,
  pageLoads: [],
  pageLoadComplete: false,
  lastPageLoadSessionId: null
};

/**
 * Subscribe a component to the traffic tracker singleton. Returns the current
 * snapshot plus the control actions.
 */
export function useTrafficTracker() {
  const snapshot = useSyncExternalStore(trafficTracker.subscribe, trafficTracker.getSnapshot, () => serverSnapshot);
  return {
    ...snapshot,
    setEnabled: on => trafficTracker.setEnabled(on),
    setRecording: on => trafficTracker.setRecording(on),
    clearActive: () => trafficTracker.clearActive(),
    saveSession: name => trafficTracker.saveSession(name),
    deleteSession: id => trafficTracker.deleteSession(id)
  };
}